import { getRouteParams } from '../../routing/getRouteParams';
export const getIsInCam0001VariantA = () => {
  const {
    queryParams
  } = getRouteParams();
  const externalExperimentParameter = queryParams['external-experiment-parameter'];
  return externalExperimentParameter === 'cam-0001-group-variant_a';
};